import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import StockLogModal from "./modules/StockLogModal";
import StockLogDrawer from "./modules/StockLogDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@/api/manage';
export default {
  name: 'StockInfoList',
  mixins: [JeecgListMixin],
  components: {
    StockLogDrawer: StockLogDrawer,
    StockLogModal: StockLogModal
  },
  data: function data() {
    return {
      pagePath: '/stock/info',
      pageTitle: '库存数量及金额',
      autoLoadInit: false,
      companyList: [],
      url: {
        queryCompany: '/ea/company/info/queryCompanyName'
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'companyName',
        colName: 'companyName',
        title: '供应商',
        align: 'center'
      }, {
        dataIndex: 'name',
        colName: 'name',
        title: '产品名称',
        align: 'center'
      }, {
        dataIndex: 'model',
        colName: 'model',
        title: '产品型号',
        align: 'center'
      }, {
        dataIndex: 'unit_dictText',
        colName: 'unit',
        title: '产品单位',
        align: 'center'
      }, {
        dataIndex: 'sumAmount',
        colName: 'sum_amount',
        title: '产品库存',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  props: {
    productCategory: {
      type: Number,
      default: 0
    }
  },
  created: function created() {
    // this.queryParam.productCategory =this.productCategory
    // this.pagePath = this.pagePath + "?productCategory=" + this.productCategory
    this.queryParam.productCategory = this.productCategory;
    this.loadCompany();
    this.loadData();
  },
  computed: {},
  methods: {
    handleAdd: function handleAdd() {
      if (this.productCategory == 91) this.$refs.modalForm.title = "新增：" + "易耗品入库记录";else if (this.productCategory == 92) this.$refs.modalForm.title = "新增：" + "备品入库记录";else if (this.productCategory == 93) this.$refs.modalForm.title = "新增：" + "备件入库记录";else if (this.productCategory == 99) this.$refs.modalForm.title = "新增：" + "其他入库记录"; // this.$refs.modalForm.title = '新增：' + "易耗品入库记录"

      this.$refs.modalForm.productCategory = this.productCategory;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
      this.$refs.modalForm.add();
    },
    handleEdit: function handleEdit(record) {
      if (this.productCategory == 91) this.$refs.modalForm.title = "新增：" + "易耗品出库记录";else if (this.productCategory == 92) this.$refs.modalForm.title = "新增：" + "备品出库记录";else if (this.productCategory == 93) this.$refs.modalForm.title = "新增：" + "备件出库记录";else if (this.productCategory == 99) this.$refs.modalForm.title = "新增：" + "其他出库记录"; // this.$refs.modalForm.title = '新增：' + "易耗品入库记录"

      this.$refs.modalForm.productCategory = this.productCategory;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
      this.$refs.modalForm.edit(record);
    },
    loadStockLogList: function loadStockLogList(productId) {
      this.$refs.StockLogModal.add(productId);
    },
    modalFormOk: function modalFormOk() {
      this.queryParam = {
        productCategory: this.productCategory
      };
      this.loadData(1);
    },
    searchReset: function searchReset() {
      this.queryParam = {
        productCategory: this.productCategory
      };
      this.dates = {};
      this.loadData(1);
    },
    loadCompany: function loadCompany() {
      var that = this;
      that.companyList = [];
      getAction(this.url.queryCompany).then(function (res) {
        if (res.success) {
          that.companyList = res.result;
        }
      });
    }
  }
};